import React from "react";
import PropTypes from "prop-types";
import get from "lodash.get";
import pure from "recompose/pure";
import {translate} from "admin-on-rest";

const TextField = ({
  source,
  record = {},
  elStyle,
  labelStyle,
  recordStyle,
  adornmentStyle,
  translate,
  customLabel,
  adornmentText,
  separator,
  separatorStyle
}) => {
  return (
    <span style={elStyle}>
      {customLabel ? (
        <span style={labelStyle}>
          {translate(customLabel)}
          {separator ? separator : null}{" "}
        </span>
      ) : null}
      <span style={recordStyle}> {get(record, source)}</span>
      {adornmentText ? (
        <span style={adornmentStyle}>{translate(adornmentText)}</span>
      ) : null}
    </span>
  );
};

TextField.propTypes = {
  addLabel: PropTypes.bool,
  showNumber: PropTypes.bool,
  elStyle: PropTypes.object,
  label: PropTypes.string,
  customLabel: PropTypes.string,
  separator: PropTypes.string,
  adornmentText: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string.isRequired
};

const PureTextField = pure(TextField);

PureTextField.defaultProps = {
  addLabel: false
};

export default translate(PureTextField);



// WEBPACK FOOTER //
// ./src/components/CRM/TextField.js